import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as style from './styles.css';

import { trackScrollInformation } from '../../tracking';
import { isContainerVisible } from '../../../../utils/containerVisible';

export interface IHowItWorksContent {
  icon: any; // eslint-disable-line
  text: string;
}

export interface IWhyTrustItem {
  numberClassName: string;
  iconClassName: string;
  title: string;
  text: string;
}

const arrow = require('../../../../static/images/Arrow.svg');
const search = require('../../../../static/images/search-3_decol_o.svg');
const brain = require('../../../../static/images/brain_o.svg');
const drawing = require('../../../../static/images/blueprint-2_decol_o.svg');
const browser = require('../../../../static/images/browser-3_decol_o.svg');

const howItWorksContent: IHowItWorksContent[] = [
  {
    icon: search,
    text: 'Вы вводите адрес и параметры квартиры',
  },
  {
    icon: drawing,
    text: 'Мы подбираем объявления и сделки аналогичных квартир',
  },
  {
    icon: brain,
    text: 'Алгоритмы ИИ вносят поправки к оценке',
  },
  {
    icon: browser,
    text: 'Формируем отчет рыночной стоимости квартиры',
  },
];

const whyTrustContent = [
  {
    numberClassName: 'reasons_first',
    iconClassName: 'analogs',
    title: 'Учитываем только аналогичные квартиры',
    text: `На цену квартиры влияют десятки параметров, в том числе характеристики дома (расположение, год постройки,
    тип стен и т.д.), характеристики квартиры (этаж, количество комнат, тип ремонта и т.д.) и многое другое.
    Для оценки выбираем квартиры с максимально похожими параметрами`,
  },
  {
    numberClassName: 'reasons_second',
    iconClassName: 'overstatement',
    title: 'Высокая точность оценки',
    text: `Оценка Циан – это не агрегированная информация о цене в объявлениях или цене в договорах купли-продажи.
    Мы используем алгоритмы искусственного интеллекта со множеством поправочных коэффициентов, что позволяет
    избежать завышения и занижения цены`,
  },
  {
    numberClassName: 'reasons_third',
    iconClassName: 'database',
    title: 'База 2,5 млн. объявлений и сделок',
    text: `У нас одна из самых больших баз объявлений и сделок. Учитываем динамику спроса и предложения и данные
    о рыночных сделках`,
  },
  {
    numberClassName: 'reasons_fourth',
    iconClassName: 'details',
    title: 'Внимание к деталям',
    text: 'Получайте более точную оценку, указав тип ремонта, вид из окон, срочность продажи и другие параметры',
  },
];

export function howItWorksRenderRow(items: IHowItWorksContent[]) {
  return items.map((item, index) => {
    return (
      <React.Fragment key={index}>
        <div className={style['items']}>
          <img src={item.icon} />
          <p>{item.text}</p>
        </div>
        {index !== items.length - 1 && <img className={style['arrow']} src={arrow} />}
      </React.Fragment>
    );
  });
}

export function whyTrustRenderItems(items: IWhyTrustItem[]) {
  return items.map((item, index) => {
    const { numberClassName, iconClassName, title, text } = item;

    return (
      <div key={index} {...mergeStyles(style['reasons_number'], style[numberClassName])}>
        <p {...mergeStyles(style['reasons_title'], style[iconClassName])}>{title}</p>
        <div className={style['params']}>
          <p>{text}</p>
        </div>
      </div>
    );
  });
}

export class Valuation extends React.Component {
  private container = React.createRef<HTMLDivElement>();
  private reasons = React.createRef<HTMLDivElement>();
  private arrayOfElements = [
    {
      container: this.container,
      label: 'HowItWorks',
    },
    {
      container: this.reasons,
      label: 'Reasons',
    },
  ];

  public componentDidMount() {
    window.addEventListener('scroll', this.handleShowInformation);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShowInformation);
  }

  private handleShowInformation = () => {
    this.arrayOfElements = this.arrayOfElements.filter(item => {
      if (isContainerVisible(item.container)) {
        trackScrollInformation(item.label);

        return false;
      }

      return true;
    });

    if (this.arrayOfElements.length === 0) {
      window.removeEventListener('scroll', this.handleShowInformation);
    }
  };

  public render() {
    return (
      <div className={style['valuation']}>
        <p className={style['title']}>Как работает оценка Циан ?</p>
        <div className={style['container']} ref={this.container}>
          {howItWorksRenderRow(howItWorksContent)}
        </div>
        <p className={style['reasons']} ref={this.reasons}>
          Почему стоит доверять оценке Циан?
        </p>

        {whyTrustRenderItems(whyTrustContent)}
      </div>
    );
  }
}
